import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useGeneralStore } from '@/pinia'
import { useStore } from 'vuex'
import ButtonText from '@/design-system/atoms/buttons/ButtonText.vue'
import TableCustomMini, { TableItem } from '@/design-system/molecules/TableCustomMini.vue'
import { Attachment } from '@/services/attachments.service'

type Props = {
  fields: any[]
  items?: Attachment[]
}
type Emits = {
  (e: 'archiveLink'): void
  (e: 'deleteLink'): void
  (e: 'loadMoreLinks'): void
}

export default /*@__PURE__*/_defineComponent({
  __name: 'TableLinksMini',
  props: {
    fields: {},
    items: {}
  },
  emits: ["archiveLink", "deleteLink", "loadMoreLinks"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit
const { t } = useI18n()

const piniaStore = useGeneralStore()
const store = useStore()

const linksTable = ref()

const currentOverlayModalPinia = computed(() => {
  return piniaStore.currentOverlayModalPinia
})
const linkItems = computed<TableItem[]>(() => {
  if (!props.items) return []
  return props.items.map((item) => {
    return {
      id: item.attachmentId,
      name: item.name,
      entityId: item.entityId,
      active: true // Currently, we expect all links in the list to be active (not archived or deleted)
    }
  })
})
const selectedId = computed(() => {
  return piniaStore.selectedLink?.attachmentId ?? ''
})
const showOverlayModalPinia = computed(() => {
  return piniaStore.showOverlayModalPinia
})

function openLink(item: TableItem) {
  if (!props.items) return
  const link = props.items.find((link) => link.attachmentId === item.id)
  if (link) window.open(link.url)
}
function setFullLinkById(id: string) {
  if (!props.items) return
  let link = props.items.find((link) => link.attachmentId === id)
  if (link) piniaStore.setSelectedLink(link)
}
watch(showOverlayModalPinia, () => {
  if (!showOverlayModalPinia.value) {
    piniaStore.setSelectedLink(null)
  }
})
watch(
  () => piniaStore.selectedLink,
  () => {
    if (!piniaStore.selectedLink) {
      linksTable.value.closeMenu()
    }
  }
)
function toggleEditLink(item: TableItem | null) {
  linksTable.value.closeMenu()
  if (!item) return piniaStore.setSelectedLink(null)
  setFullLinkById(item.id)
  if (showOverlayModalPinia.value && currentOverlayModalPinia.value === 'editTicket') {
    // For tickets, modal on modal was a joint decision on prod/tech review 2024-08-19
    piniaStore.setCurrentOverlayModalOnModalPinia('editTicketLink')
    piniaStore.setShowOverlayModalOnModalPinia(true)
    return
  }
  piniaStore.setCurrentOverlayModalPinia('editLink')
  piniaStore.setShowOverlayModalPinia(true)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TableCustomMini, {
    ref_key: "linksTable",
    ref: linksTable,
    class: "table-custom-mini",
    fields: _ctx.fields,
    hasArchiveButton: _unref(store).getters.hasLinkEditorAccess,
    hasCreateButton: _unref(store).getters.hasLinkCreatorAccess,
    hasDeleteButton: _unref(store).getters.hasLinkAdminAccess,
    hasEditButton: _unref(store).getters.hasLinkEditorAccess,
    hasMenu: _unref(store).getters.hasLinkEditorAccess,
    items: linkItems.value,
    itemType: _unref(t)('general__data__links'),
    selectedId: selectedId.value,
    onArchiveItem: _cache[0] || (_cache[0] = ($event: any) => (emits('archiveLink'))),
    onDeleteItem: _cache[1] || (_cache[1] = ($event: any) => (emits('deleteLink'))),
    onEditItem: toggleEditLink,
    onLoadMore: _cache[2] || (_cache[2] = ($event: any) => (emits('loadMoreLinks'))),
    onMenuClosed: _cache[3] || (_cache[3] = ($event: any) => (_unref(piniaStore).setSelectedLink(null))),
    onMenuOpened: _cache[4] || (_cache[4] = ($event: any) => (setFullLinkById($event)))
  }, {
    preview: _withCtx(({ item }) => [
      _createVNode(ButtonText, {
        class: _normalizeClass(["table-custom-mini__button", { selected: item.id === selectedId.value }]),
        iconLeft: require('@/design-system/assets/icons/Icon-External-Link-Small.svg'),
        size: "extra-small",
        whiteContent: false,
        onOnClicked: ($event: any) => (openLink(item))
      }, null, 8, ["class", "iconLeft", "onOnClicked"])
    ]),
    _: 1
  }, 8, ["fields", "hasArchiveButton", "hasCreateButton", "hasDeleteButton", "hasEditButton", "hasMenu", "items", "itemType", "selectedId"]))
}
}

})